import {Injectable} from '@angular/core';
import {environment} from "../../environments/environment";
import {BehaviorSubject, Observable} from "rxjs";
import {filter} from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import {Deserialize} from "cerialize";
import {Contact} from "../models/contact";
import {objectToFormData} from "object-to-formdata";
import {User} from "../models/user";
import {Logement} from "../models/logement";
import {UserService} from "./user.service"

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  baseApiUrl: string = environment.api.baseUrl;

  private _contacts: BehaviorSubject<Contact[]> = new BehaviorSubject(null);
  public readonly contacts: Observable<Contact[]> = this._contacts.asObservable().pipe(filter(contacts => contacts != null));

  constructor(private http: HttpClient, private userService: UserService) {
  }

  load(logementId: number): Promise<Contact[]> {
    return this.http.get(`${this.baseApiUrl}logement/${logementId}/contacts`).toPromise().then(data => {
      const contacts = Deserialize(data, Contact);
      this._contacts.next(contacts);
      return contacts;
    });
  }

  findById(logementId: number, contactId: number): Promise<Contact> {
    return this.http.get(`${this.baseApiUrl}logement/${logementId}/contacts/${contactId}`).toPromise().then(
      (data) => {
        return Deserialize(data, Contact);
      },
      (data) => {
        throw new Error('An unexpected error occurred while data loading : ' + data);
      });
  }

  save(logementId: number, contactId: number, contact: any): Promise<any> {

    const route = `${this.baseApiUrl}logement/${logementId}/contacts` + (contactId ? `/${contactId}` : '');

    return this.http.post(route, objectToFormData(contact)).toPromise().then(
      (data) => {
        return data;
      },
      (data) => {
        if (data.status == 400) {
          return data.error;
        }
        throw new Error('An unexpected error occurred while data loading : ' + data);
      });
  }

  delete(logementId: number, contactId: number): Promise<any> {
    return this.http.delete(`${this.baseApiUrl}logement/${logementId}/contacts/${contactId}`).toPromise().then(
      (data) => {
        return data;
      },
      (data) => {
        if (data.status == 400) {
          return data.error;
        }
        throw new Error('An unexpected error occurred while data loading : ' + data);
      });
  }

  openToLocataires(logementId: number, contactId: number): Promise<any> {
    return this.http.get(`${this.baseApiUrl}logement/${logementId}/contacts/${contactId}/open-to-locataires`).toPromise().then(
      (data) => {
        return data;
      },
      (data) => {
        if (data.status == 400) {
          return data.error;
        }
        throw new Error('An unexpected error occurred while data loading : ' + data);
      });
  }

  closeToLocataires(logementId: number, contactId: number): Promise<any> {
    return this.http.get(`${this.baseApiUrl}logement/${logementId}/contacts/${contactId}/close-to-locataires`).toPromise().then(
      (data) => {
        return data;
      },
      (data) => {
        if (data.status == 400) {
          return data.error;
        }
        throw new Error('An unexpected error occurred while data loading : ' + data);
      });
  }

  coproCanOpenToLocataires(user: User, contact: Contact, logement: Logement): boolean {
    if (this.userService.isProprietaire(logement) && contact.ajouteParParticulier == false) {
      return true;
    }
    return false;
  }

  canUpdate(contact: Contact, logement: Logement) {
    if (((logement.userPermissions.updatable && contact.ajouteParParticulier) || (this.userService.isLocataire(logement) && contact.roles.includes('ROLE_LOCATAIRE') && !contact.roles.includes('ROLE_COPROPRIETAIRE')))) {
      return true;
    } else {
      return false;
    }

  }
}
